export enum ProjectSubjectResourceType {
  DATA = "data",
  LIBRARY = "library",
  OTHER = "other",
}
